import { useEffect, useState } from "react";
import ChatComponent from "../../../components/chat/Chat";
import { DynamicTab, NewDynamicTab } from "../../../components/Page";
import { RuvnlTitle } from "../components";
import { RajasthanDiscomAnalysis } from "./Discom_Analysis";
import { RajasthanDrawal } from "./Drawal";
import { RajasthanDiscomForecast } from "./Forecast";
import {
  createThread,
  dmrcChatGptRes,
  rajChatGptRes,
} from "../Utility/RestApi";
import { RajasthanTrend } from "./TrendAnalysis";
import { RajasthanDrawalForecast } from "./Drawal_forecast";
import { TabSwitcher } from "../Raj_Dashboard";
import { RajasthanDiscomForecast2 } from "./Forecast2";
import { RajasthanDrawalTrend } from "./Drawal_Trend";
import { Rajasthan_Forecast_Surplus } from "./Forecast_Surplus";
import { RajasthanDrawalTrendUpload } from "./Drawal_Trend_upload";
import { RuvitalDemand } from "../../../config/DefaultDates";

export function RajDemand() {
  const [chatMessages, setChatMessages] = useState<
    { sender: String; content: String }[]
  >([]);
  const [gptLoading, setGptLoading] = useState(false);
  const [thread_id, setThreadId] = useState("");
  useEffect(() => {
    createThread().then((response) => {
      setThreadId(response.thread_token);
    });
  }, []);

  const _handleGptResponse = async (query: string) => {
    setChatMessages([...chatMessages, { sender: "user", content: query }]);
    setGptLoading(true);
    const response = await rajChatGptRes({
      query: query,
      thread_token: thread_id,
    });
    setChatMessages([
      ...chatMessages,
      { sender: "user", content: query },
      { sender: "ai", content: response.content },
    ]);
    setGptLoading(false);
  };
  return (
    <>
      <NewDynamicTab
        defaultDates={RuvitalDemand}
        header="Demand"
        trendTabs={["Trend Analysis", "Restricted Demand Trend Analysis"]}
        middleComponent={<RuvnlTitle />}
        headerPrefixComponent={<TabSwitcher />}
        tabs={{
          "Discom Load ": <RajasthanDiscomAnalysis />,
          "Trend Analysis": <RajasthanTrend />,
          // "Forecast Upload": <RajasthanDrawalTrendUpload />,
          "Restricted Demand": <RajasthanDrawal />,
          "Restricted Demand Trend Analysis": <RajasthanDrawalTrend />,
          "Forecast Discom Load": <Rajasthan_Forecast_Surplus />,
        }}
        // disabledTabs={["Forecast Discom Load"]}
      />
      <ChatComponent
        messages={chatMessages as any}
        defaultMessages={[
          "What is the evening hour peak demand ?",
          "What is the total load for the specified date range and time slot?",
          "What is the maximum demand for a specific discom within the given date range?",
          "What is the minimum demand for a specific discom within the given date range?",
          "What is the average load for a specific discom in the given time period?",
        ]}
        onClear={() => {
          setChatMessages([]);
          setGptLoading(false);
        }}
        isLoading={gptLoading}
        onInput={(message: string) => _handleGptResponse(message)}
      />
    </>
  );
}
